// Предикаты «есть ли что показать» для рекламных зон (PC_NEW-656).
// Один источник правды для AdTemplate (какие слайды рендерить) и для мест
// показа под ценами (OrderPrices / NotInPrice): показывать ли блок вообще
// и что приоритетнее — «Альтернатива» (зона 4, привязана к SKU) или «Новинки» (зона 3).
// Данные — массив из геттера ADS (GET /Ad/GetAll); объекты стора не мутируются.

// Ячейки слайда с картинкой: пустой sourceLink в админке означает незаполненную
// ячейку раскладки (например «12, 12» с одной картинкой), рисовать её нечем.
export function visibleContents(adItem) {
  const contents = adItem?.adItemContents || [];
  return contents.filter(
    (c) => typeof c.sourceLink === "string" && c.sourceLink.trim() !== ""
  );
}

// Слайды зоны к показу. goodsId — только слайды, привязанные к этому SKU
// (goodsId в сторе бывает строкой, сравниваем числами). hideEmpty — убрать
// пустые ячейки, слайды без единой картинки выбросить. splitCells — каждую
// ячейку сделать отдельным слайдом (id слайда = id ячейки): в боксе
// фиксированной высоты по ширине контейнера раскладка «12, 12»/«6, 6» иначе
// поставила бы две картинки рядом вдвое мельче.
export function visibleAdItems(
  ad,
  { goodsId = null, hideEmpty = false, splitCells = false } = {}
) {
  let items = ad?.adItems || [];

  if (goodsId != null) {
    items = items.filter((x) => Number(x.goodsId) === Number(goodsId));
  }

  if (hideEmpty) {
    items = items
      .map((slide) => ({ ...slide, adItemContents: visibleContents(slide) }))
      .filter((slide) => slide.adItemContents.length > 0);
  }

  if (splitCells) {
    items = items.flatMap((slide) =>
      (slide.adItemContents || []).map((content) => ({
        ...slide,
        id: content.id,
        adItemContents: [content],
      }))
    );
  }

  return items;
}

// Есть ли в зоне adLocation хоть один слайд к показу. ads может быть null,
// пока GET /Ad/GetAll не вернулся.
export function hasVisibleSlides(ads, adLocation, opts) {
  const ad = ads?.find((x) => x.id == adLocation);
  return visibleAdItems(ad, opts).length > 0;
}
